import React from 'react';
import { formatCellValue } from './formatUtils';

/**
 * FinancialTable — Professional accounting table with right-aligned numbers,
 * subtotal rows, and Swedish currency formatting.
 */
export default function FinancialTable({ artifact }) {
  const { title, columns = [], rows = [], totals, period } = artifact;

  if (!rows.length && !totals) return null;

  return (
    <div className="finn-artifact finn-financial-table">
      {(title || period) && (
        <div className="finn-artifact-header">
          {title && <span className="finn-artifact-title">{title}</span>}
          {period && <span className="finn-artifact-period">{period}</span>}
        </div>
      )}
      <div className="finn-table-scroll">
        <table>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key} style={{ textAlign: col.align || 'left' }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {columns.map((col) => {
                  const val = row[col.key];
                  const isNegative = typeof val === 'number' && val < 0;
                  return (
                    <td
                      key={col.key}
                      style={{ textAlign: col.align || 'left' }}
                      className={[
                        col.format === 'currency' || col.format === 'number' ? 'finn-num' : '',
                        isNegative ? 'finn-negative' : '',
                      ].filter(Boolean).join(' ')}
                    >
                      {formatCellValue(val, col.format)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          {totals && (
            <tfoot>
              <tr className="finn-totals-row">
                {columns.map((col) => (
                  <td
                    key={col.key}
                    style={{ textAlign: col.align || 'left' }}
                    className={col.format === 'currency' || col.format === 'number' ? 'finn-num' : ''}
                  >
                    {totals[col.key] != null ? formatCellValue(totals[col.key], col.format) : ''}
                  </td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
